module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og engelsk_primaerlogo_neg(hvit).9afea0a8.png";